import React from 'react';
import { FaCheckCircle, FaShieldAlt } from 'react-icons/fa';
import { GiPokerHand } from 'react-icons/gi';

const Footer = () => {
  return (
    <footer className="mt-10 -mb-[100px] bg-white shadow-inner">
      {/* Top Bar */}
      <div className="flex flex-col md:flex-row items-center justify-between px-4 py-4 bg-[#0088cc] md:px-10 text-white">
        <div className="flex gap-6 text-sm font-medium mb-2 md:mb-0">
          <a href="#" className="hover:underline transition-all duration-200">Terms & Conditions</a>
          <a href="#" className="hover:underline transition-all duration-200">Responsible Gaming</a>
        </div>
        <div className="text-lg md:text-2xl font-bold">
          24x7 Customer Support
        </div>
      </div>

      {/* Bottom Content */}
      <div className="flex flex-col md:flex-row items-center justify-between gap-6 px-4 py-6 md:px-10">
        {/* SSL Security */}
        <div className="flex items-start gap-3 max-w-[250px]">
          <FaShieldAlt className="text-3xl text-green-600 mt-1" />
          <div>
            <p className="text-sm font-semibold text-black">100% Secure</p>
            <p className="text-xs text-gray-600">SSL secured connection with encrypted data.</p>
          </div>
        </div>

        {/* Copyright Info */}
        <div className="text-center text-xs text-gray-700">
          © 2025 All Rights Reserved. Powered by <span className="font-semibold text-black">ALLPANELEXCH</span>.
        </div>

        {/* Footer Icons */}
        <div className="flex items-center gap-4">
          <div className="relative">
            <GiPokerHand className="text-3xl text-black" />
            <span className="absolute -top-2 -right-2 text-[10px] text-white bg-red-600 rounded-full w-5 h-5 flex items-center justify-center shadow-sm">18+</span>
          </div>
          <FaCheckCircle className="text-2xl text-black" />
          <GiPokerHand className="text-3xl text-black" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
